import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Property } from "./property.model";

/**
 * @class Supplier
 * 
 */
export class Supplier extends Model {
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'SUPPLIER_NAME'
            },
        };
    }
}

AccessorsMutatorsDecorator(
    'id',
    'property',
    'name',
    'status',
    'country_id',
    'city_id',
    'address',
    'contact_name',
    'email',
    'phone_code',
    'phone_number',
    'notes',
    'country',
    'city',
    'country_name',
    'city_name',
    'phone',
    'furniture',
    'vat_number',
)(Supplier);



// WEBPACK FOOTER //
// ./src/pms-api/models/supplier.model.js